import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';
import { onIdTokenChanged } from 'firebase/auth';

import Navbar from '../components/Navbars/AppNavbar.js';
import Footer from '../components/Footers/Footer.js';
import FooterSM from '../components/Footers/FooterSmall.js';
import ProfileComponent from '../components/Profile/ProfileComponent';
import { firebaseAuthFunc } from '../config/firebaseAuth.js';

export default function Wallet() {
  const router = useRouter();

  useEffect(() => {
    onIdTokenChanged(firebaseAuthFunc, (user, err) => {
      if (!user) {
        router.push('/auth/login?page=wallet');
      }
    });
  }, []);

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        <link rel="canonical" href="https://musicart.io/wallet" />
      </Head>
      <Navbar transparent />
      <ProfileComponent />
      <Footer />
      <FooterSM />
    </>
  );
}
